import { InteractionRequiredAuthError } from "@azure/msal-browser";

let loginTrackTries = 0;
let pendingLogin = false;

// Shared MSAL client injected from msal-context.js
let sharedClient = null;

export default class Auth {
  setClient(client) {
    sharedClient = client;
  }

  login() {
    if (!sharedClient) {
      console.error("Auth.login called before MSAL client was set.");
      return;
    }
    sharedClient.loginRedirect({ scopes: ["openid", "profile"] });
  }

  logout() {
    localStorage.clear();

    if (!sharedClient) {
      window.location.href = "/";
      return;
    }

    if (sharedClient.logoutRedirect) {
      sharedClient.logoutRedirect();
    } else {
      sharedClient.logout();
    }
  }

  getToken = async () => {
    if (!sharedClient) {
      console.error("Auth.getToken called before MSAL client was set.");
      return null;
    }

    const accounts = sharedClient.getAllAccounts();
    if (!accounts || accounts.length === 0) return null;

    const account = accounts[0];

    const request = {
      scopes: [process.env.REACT_APP_AZURE_API_SCOPE],
      account,
      forceRefresh: false,
    };

    try {
      const tokenResponse = await sharedClient.acquireTokenSilent(request);

      localStorage.setItem("msal.idtoken", tokenResponse.accessToken);

      const username = account.username;
      const userInfoRaw = localStorage.getItem("user");
      if (userInfoRaw) {
        const userInfo = JSON.parse(userInfoRaw);
        userInfo.Id = tokenResponse.uniqueId;
        userInfo.mail = username;
        localStorage.setItem("user", JSON.stringify(userInfo));
      } else {
        localStorage.setItem(
          "user",
          JSON.stringify({ Id: tokenResponse.uniqueId, mail: username })
        );
      }

      return tokenResponse.accessToken;
    } catch (error) {
      console.log(error);

      if (
        error instanceof InteractionRequiredAuthError ||
        error.name === "InteractionRequiredAuthError"
      ) {
        await sharedClient.acquireTokenRedirect(request);
        return null;
      }

      return null;
    }
  };

  async trackLogin(claims) {
    const self = this;

    if (pendingLogin) return;
    pendingLogin = true;

    //check if the user has been logged into the DB for today
    const n = new Date().toLocaleDateString();
    if (localStorage.getItem("LogInMetric") === n) {
      pendingLogin = false;
      return true;
    }

    setTimeout(async () => {
      try {
        const user = {
          UserId: claims?.oid,
          Username:
            claims?.preferred_username || claims?.upn || claims?.unique_name,
          Location: claims?.ctry,
          browserspecs: JSON.stringify(navigator.userAgent),
        };

        const accessToken = await self.getToken();
        if (!accessToken) {
          pendingLogin = false;
          return;
        }

        fetch("/api/userLogin", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken,
            withCredentials: true,
            crossDomain: true,
          },
          body: JSON.stringify(user),
        })
          .then((response) => {
            if (response.status !== 200 && loginTrackTries < 3) {
              setTimeout(() => {
                loginTrackTries++;
                self.trackLogin(claims);
              }, 3000);
            } else {
              localStorage.setItem("LogInMetric", n);
              return response.json();
            }
          })
          .then((data) => {
            const userData = localStorage.getItem("user");
            if (userData) {
              const x = JSON.parse(userData);
              x.FetchTipAvailable = data?.FetchTipActive;
              localStorage.setItem("user", JSON.stringify(x));
            }
          })
          .catch((error) => console.error("Error:", error))
          .finally(() => {
            pendingLogin = false;
          });
      } catch (e) {
        console.error("TrackLogin error:", e);
        pendingLogin = false;
      }
    }, 5000);
  }
}
